import * as React from 'react';
import { RouteObject, Outlet } from 'react-router-dom';

const ClientContactsTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-surveys-responses" */ '../../../../containers/Client/Contacts/children/ContactsTable'
        )
);
const ClientContactInfo = React.lazy(
    () =>
        import(
            /* webpackChunkName: "client-surveys-response" */ '../../../../containers/Client/Contacts/children/ContactInfo'
        )
);

export const ClientContactsRoutes: RouteObject = {
    path: 'contacts',
    element: <Outlet />,
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientContactsTable />
                </React.Suspense>
            )
        },
        {
            path: 'contact/:contactId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <ClientContactInfo />
                </React.Suspense>
            )
        }
    ]
};
